import {
  PieChartDS,
  PieChartData,
} from "@qivia/ui/src/designSystem/components/Charts/PieChart";
import { TotalType } from "@qivia/ui/src/designSystem/components/Charts/CardChart";
import { useTranslation } from "react-i18next";
import { EmptyChart } from "./emptyChart";
import { TotalAmountPerMerchantGroupType } from "../../transactions/transactionsAPI";
import { GetTransactionsAmountsPerPeriodType } from "../../transactions/transactionsAPI";
import "../../../../i18n/i18n";

export const MerchantGroupsPieChart = (props: {
  totalType: TotalType;
  data: GetTransactionsAmountsPerPeriodType;
}) => {
  const { t } = useTranslation();

  let totalAmount = 0;
  const mapMerchantGroups = (
    merchantGroup: TotalAmountPerMerchantGroupType,
  ) => {
    const percentage = (merchantGroup.amount / totalAmount) * 100;
    return {
      name: merchantGroup.merchantGroup
        ? t(
            `dashboard.charts.title.merchantGroups.${merchantGroup.merchantGroup}`,
          )
        : t("dashboard.charts.title.merchantGroups.OTHER"),
      value: percentage,
    };
  };

  let merchantGroupsData: PieChartData[] = [];

  if (props.totalType === "month") {
    totalAmount = props.data.month.merchantGroupsAmounts.reduce(
      (acc, curr) => acc + curr.amount,
      0,
    );
    merchantGroupsData =
      props.data.month.merchantGroupsAmounts.map(mapMerchantGroups);
  } else if (props.totalType === "quarter") {
    totalAmount = props.data.quarter.merchantGroupsAmounts.reduce(
      (acc, curr) => acc + curr.amount,
      0,
    );
    merchantGroupsData =
      props.data.quarter.merchantGroupsAmounts.map(mapMerchantGroups);
  } else if (props.totalType === "year") {
    totalAmount = props.data.year.merchantGroupsAmounts.reduce(
      (acc, curr) => acc + curr.amount,
      0,
    );
    merchantGroupsData =
      props.data.year.merchantGroupsAmounts.map(mapMerchantGroups);
  }

  return (
    <>
      {!merchantGroupsData.length ? (
        <EmptyChart />
      ) : (
        <PieChartDS
          categoryData={merchantGroupsData}
          unit="%"
          displayPercentageLegend={true}
        />
      )}
    </>
  );
};
